/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label, Button, InputGroup,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';

import { post } from '../../helpers/api_helper';

function PalletLabelsForm(props) {
  const { onSuccess, t } = props;

  const [loading, setLoading] = useState(false);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const save = async (values) => {
    try {
      if (loading) return;

      setLoading(true);

      const result = await post('/api/tvs/pallets', values);

      props.onSuccess(result);
    } catch (error) {
      toastr.error(t('Error saving addressing'), t('Error'));
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    classification: Yup.string().required(t('Classification is required')),
    qty: Yup.number().required(t('Qty is required')),
  });

  const jsx = (
    <Formik
      enableReinitialize
      initialValues={{ classification: '', qty: 1 }}
      validationSchema={ValidationSchema}
      onSubmit={(values) => {
        save(values);
      }}
    >
      {({
        touched, errors, values, setFieldValue,
      }) => (
        <Form id="PalletLabelsForm" autoComplete="off">
          <div className="mb-3">
            <Field
              as="select"
              className={`form-control ${(errors.classification && touched.classification ? 'is-invalid' : '')}`}
              id="classification"
              name="classification"
            >
              <option value="">{props.t('Select Classification')}</option>
              <option value="T">(T) Teardown</option>
              <option value="R">(R) Repair</option>
              <option value="P">(P) Plug and Play</option>
              <option value="S">(S) Korea Samsung</option>
              <option value="L">(L) Korea LG</option>
              <option value="H">(H) MI Tech Hisense</option>
              <option value="3">(3) MI Tech 32"</option>
              <option value="M">(M) MI Tech Samsung</option>
              <option value="K">(K) K-Bid</option>
              <option value="V">(V) Korea Vizio</option>
              <option value="B">(B) Korea Samsung Good Back</option>
              <option value="Z">(Z) Samsung and LG Teardown Boxed</option>
              <option value="Y">(Y) Other Brands Teardown Boxed</option>
            </Field>
            <ErrorMessage
              name="classification"
              component="div"
              className="text-danger mt-1"
            />
          </div>

          <div>
            <InputGroup>
              <Field min="1" step="1" type="number" name="qty" className="form-control" placeholder="Qty" />
              <Button color="success" className="text-dark">
                <span className="mdi mdi-print" />
                {' '}
                {t('Print')}
              </Button>
            </InputGroup>
          </div>
        </Form>
      )}
    </Formik>
  );

  return jsx;
}

PalletLabelsForm.defaultProps = {
  onSuccess: () => {},
};

PalletLabelsForm.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  onSuccess: PropTypes.func,
};

export default connect((state) => ({

}), {})(withTranslation()(PalletLabelsForm));
